import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { PATHS } from '../../common/constants';
import {
  clearSuiteUsers,
  fetchSuiteCounts,
  onSubmitKeyhandOffProcess,
  onFetchSuiteDetails,
  onFetchMoreDetails,
  onClearMoreDetails,
  reRenderKeyPickupPdf,
} from '../../store/actions/suites';
import { selectSuiteById, selectSuites } from '../../store/selectors/suites';
import Breadcrumb from '../../components/Breadcrumb';
import Card from '../../components/Card';
import HeadingWithDetails from '../../components/HeadingWithDetails';
import Icon from '../../components/Icon';
import Metrics from '../../components/Metrics';
import Tabs from '../../components/Tabs';
import WithNavigation from '../../layouts/WithNavigation';
import SuiteAssets from './SuiteAssets';
import SuiteServiceRequests from './SuiteServiceRequests';
import SuiteMessages from './SuiteMessages';
import SuiteNotes from './SuiteNotes';
import SuiteDocuments from './SuiteDocuments';
import SuiteWalkThroughs from './SuiteWalkThroughs';
import Tenant from '../../components/Tenant';
import Avatar from '../../components/Avatar';
import moment from 'moment';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import {
  selectNotes,
  selectDocuments,
} from '../../store/selectors/faqsNotesDocuments';
import {
  fetchPropertySuites,
  updateSuite,
  deleteUnit,
} from '../../store/actions/suites';
import Overlay from '../../components/Overlay';
import SuiteForm from '../../components/SuiteForm';
import {
  setSuiteFormData,
  clearSuiteFormData,
} from '../../store/actions/suiteForm';
import {
  selectAuthenticatedUser,
  selectpropertyManagerDetails,
} from '../../store/selectors/auth';
import { clearMessages } from '../../store/actions/Messages';
import { selectMessages } from '../../store/selectors/Messages';
import {
  selectPropertyById,
  selectProperties,
} from '../../store/selectors/properties';
import { clearServiceRequests } from '../../store/actions/serviceRequests';
import { clearAssets } from '../../store/actions/assets';
import {
  clearFaqsNotesDocuments,
  clearNotes,
} from '../../store/actions/faqsNotesDocuments';
import { fetchSuiteWalkThroughs } from '../../store/actions/walkThroughs';
import { selectAssets } from '../../store/selectors/assets';
import { upload } from '../../helpers/upLoadHelper';
import { selectServiceRequests } from '../../store/selectors/serviceRequests';
import {
  fetchProperties,
  clearCountsDone,
} from '../../store/actions/properties';
import { fetchAssetsBySuiteId } from '../../store/actions/assets';
import { selectWalkThroughByRole } from '../../store/selectors/walkThrough';
import SuiteUsers from './SuiteUsers';
import { selectSuiteUsers } from '../../store/selectors/suiteUsers';
import { selectCounts } from '../../store/selectors/Counts';
import {
  fetchCalendlyLink,
  fetchPropertyManagerDetails,
} from '../../store/actions/auth';
import { variables } from '../../Tenants';
import SuiteMaintainanceGuide from './SuiteMaintainanceGuide';
import { Link } from 'react-router-dom';
import { selectPropertyWalkThroughFormIsVisible } from '../../store/selectors/propertyWalkThroughForm';
import PropertyWalkThroughForm from '../../components/PropertyWalkThroughForm';
import { getAllUserTypeRoles } from '../../store/actions/formOptions';
import { selectFormOptions } from '../../store/selectors/formOptions';
import Keyhandoff from './Keyhandoff';
import { selectSuiteFormData } from '../../store/selectors/suiteForm';
import MoreDetails from './MoreDetails';
import { selectLoader } from '../../store/selectors/loader';
import {
  onRequestPhoneCall,
  serviceRequestTableLocalTime,
} from '../../helpers/validationHelper';
import { startFormLoading, stopFormLoading } from '../../store/actions/loader';
import * as client from '../../services/client';
import SuiteFaqs from './SuiteFaqs';
import { fetchtAllowedTabList } from '../../store/actions/tabSelections';
import { store } from '../../store';
import FeedBack from '../../components/FeedBack';
import { fetchFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { BrandingContext } from '../../branding/BrandingContextProvider';
import { Headline } from './header/header';
import { MobileDownloadIcon } from '../../components/SuitesTable/components/mobileDownloadIcon';

class Suite extends Component {
  state = {
    showOverlay: false,
    isEventShow: false,
    showOverlayKeyHandoff: false,
    suite: {},
    feedBackReportPopup: false,
  };
  fetchSuiteById(id) {
    this.props.startFormLoading();
    client
      .getPropertySuiteById(id)
      .then((response) => {
        if (response.ok || response.status === 200) {
          response.json().then((responsejson) => {
            this.props.stopFormLoading();
            this.setState({ suite: responsejson });
          });
        } else {
          this.props.stopFormLoading();
        }
      })
      .catch((e) => this.props.stopFormLoading());
  }

  toggleMobileSync() {
    const { suite } = this.state;
    suite.mobileSyncAllowed = !suite.mobileSyncAllowed;
    this.setState({ suite });
  }

  async componentDidMount() {
    const {
      onFetchFaqsNotesDocuments,
      onFetchProperties,
      onFetchPropertyManagerDetails,
      onFetchCalendlyLink,
      propertyManagerDetails,
      match,
      onFetchPropertySuites,
      clearServiceRequests,
      clearAssets,
      clearMessages,
      user,
      onfetchAssetsBySuiteId,
      onClearSuiteUsers,
      properties,
      suites,
      clearCountsDone,
      getAllUserTypeRoles,
      onClearSuiteFormData,
      fetchtAllowedTabList,
      clearNotes,
    } = this.props;
    const { suite } = this.state;
    clearNotes();
    await onFetchFaqsNotesDocuments(this.props.location.state?.suite?.id);
    const { branding } = this.context;
    fetchtAllowedTabList(this.props.location.state?.property?.id, branding);
    onClearSuiteFormData();
    onClearSuiteUsers();
    clearCountsDone();
    getAllUserTypeRoles();
    let string = window.location.href;
    let isEventShow = string.includes('openCalendly');
    this.setState({ isEventShow: isEventShow });
    const isShowHomeownerDasboardPage =
      JSON.parse(localStorage.getItem('showHomeownerDasboardPage')) ?? false;
    if (
      user &&
      user.roles &&
      user.roles.length > 0 &&
      user.roles[0].role.name === 'Home Owner' &&
      isShowHomeownerDasboardPage === false
    ) {
      let isfeedBackReportPopup = localStorage.getItem(
        'IsHomerNavigatFromFeedBackTemplate'
      );
      if (
        isfeedBackReportPopup !== undefined &&
        isfeedBackReportPopup !== null &&
        isfeedBackReportPopup !== ''
      ) {
        this.setState({ feedBackReportPopup: true });
      }
    }
    if (
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].role.name === 'Home Owner' ||
        user.roles[0].role.name === 'Occupant')
    ) {
      if (propertyManagerDetails && propertyManagerDetails.email) {
        onFetchCalendlyLink(propertyManagerDetails.email);
      } else {
        await onFetchPropertyManagerDetails(user.id, true);
      }
    }
    const suiteId = match.params.id.split('&');
    this.props.fetchSuiteWalkThroughs(
      suiteId[1],
      user.roles[0].role.name,
      true
    );
    this.fetchSuiteById(suiteId[1]);

    if (suite && suite.id) {
    } else {
      await onFetchProperties(user.id, user.roles[0].role.name);
      if (suites && suites.length === 0) {
        onFetchPropertySuites(suiteId[0], user.id, user.roles[0].role.name);
      }
    }

    let value = this.props.location.state;
    let splitValue = string.split('activeTab=')[1];
    if (user && user.id && splitValue !== undefined) {
      onFetchProperties(user.id, user.roles[0].role.name);
    } else {
      if (properties && properties.length === 0) {
        onFetchProperties(user.id, user.roles[0].role.name);
      }
    }

    if (value && value.onNavigationBack) {
    } else {
      clearAssets();
      clearMessages();
      clearServiceRequests();
    }
    clearFaqsNotesDocuments();
    const serviceRequestId = this.props.location.state
      ? this.props.location.state.data
        ? this.props.location.state.data.serviceRequestId
        : null
      : null;

    if (serviceRequestId != null) {
      onFetchPropertySuites(suiteId[2], user.id, user.roles[0].role.name);
    }
    if (suites && suites.length === 0) {
      onFetchPropertySuites(suiteId[0], user.id, user.roles[0].role.name);
    }

    if (this.props.location.state && this.props.location.state?.property?.id) {
      onFetchPropertySuites(
        this.props.location.state?.property?.id,
        user.id,
        user.roles[0].role.name
      );
    }
    this.props.onFetchSuiteCounts(suiteId[1], user.roles[0].role.name);
    onfetchAssetsBySuiteId(suiteId[1]);
  }

  onSaveSuite = async (suite, suiteAreas, floorImage) => {
    const { onUpdateSuite, onfetchAssetsBySuiteId } = this.props;

    let imageUrl = null;
    let newImage = false;
    if (floorImage === suite.floorPlanURL) {
      imageUrl = suite.floorPlanURL;
    } else {
      if (suite.floorPlanURL && suite.floorPlanURL.length > 0) {
        newImage = true;
        imageUrl = await upload(suite.floorPlanURL[0]);
      }
    }
    let params = {};
    let parkingStalls = [];
    let storageLockers = [];
    if (suite && suite.parkingStalls && suite.parkingStalls.length > 0) {
      suite.parkingStalls.map((ps) => {
        let obj = {
          Name: ps.label,
          Type: 'ParkingStalls',
        };
        parkingStalls = [...parkingStalls, obj];
      });
    }
    if (suite && suite.storageLockers && suite.storageLockers.length > 0) {
      suite.storageLockers.map((ps) => {
        let obj = {
          Name: ps.label,
          Type: 'StorageLockers',
        };
        storageLockers = [...storageLockers, obj];
      });
    }
    if (suite.id) {
      await suiteAreas.map((item) => {
        if (item.type === 'Other') {
          delete item.id;
        }
      });
      params = {
        id: suite.id,
        statusId: suite.statusId,
        propertyId: suite.propertyId,
        number: suite.number.trim(),
        stratalot: suite.stratalot ? suite.stratalot.trim() : '',
        Userid: this.props.user.id,
        Areas: suiteAreas,
        floorPlanURL: imageUrl,
        assetWarrantyDefaultStartDate: suite.assetWarrantyDefaultStartDate
          ? new Date(moment(suite.assetWarrantyDefaultStartDate).format('l LT'))
          : null,
        warrantyNumber: suite.warrantyNumber,
        warrantyAddress: suite.warrantyAddress,
        Building: suite.Building,
        BuildingId: suite.BuildingId ? suite.BuildingId : null,
        Level: suite.Level,
        LevelId: suite.LevelId ? suite.LevelId : null,
        ParkingStalls: parkingStalls,
        StorageLockers: storageLockers,
        newImage: newImage,
        KeyFobs: suite.keyFobs,
        NumberOfKeys:
          suite.numberOfKeys === null || suite.numberOfKeys === undefined
            ? 0
            : Number(suite.numberOfKeys),
        KeyHandOffInstructions: suite.keyHandOffInstructions,
        suiteKeysAndValues: suite.suiteKeysAndValues,
      };
      await onUpdateSuite(params);
      await this.fetchSuiteById(suite.id);
      this.props.onFetchSuiteCounts(
        suite.id,
        this.props.user.roles[0].role.name
      );
      onfetchAssetsBySuiteId(suite.id);
    }
  };

  onDeleteUnit(unitId) {
    let { onDeleteUnit, user } = this.props;
    const { property } = this.props.location.state;
    onDeleteUnit(unitId, user.id, this.props.history, property);
  }

  fetchDetails = async () => {
    const { onSetSuiteFormData } = this.props;
    const { suite } = this.state;
    onSetSuiteFormData(suite);
    onSetSuiteFormData({ old: true });
    this.setState({ showOverlayKeyHandoff: true });
  };

  onFetchMoreDetails = () => {
    this.props.onFetchMoreDetails(this.props.suite.id);
  };

  //TODO: fetch *more* details????????????????????? (Backlog-508)[https://trello.com/c/s9TsJbIu]
  reRenderKeyPickupPdf = () => {
    const { suite } = this.state;
    const { onReRenderKeyPickupPdf } = this.props;
    onReRenderKeyPickupPdf(suite.id);
  };

  static contextType = BrandingContext;

  render() {
    const {
      onSetSuiteFormData,
      suiteFormData,
      onClearSuiteFormData,
      match,
      property,
      user,
      counts,
      propertyWalkThroughFormIsVisible,
      moreDetails,
      tabSelections,
      notesList,
    } = this.props;

    const { branding } = this.context;

    const HmeOwnrOcpntRltrNotes = [];
    let noteVisibleToHomeownerOccupantRealtor = false;
    if (notesList && notesList.length > 0) {
      let notes = notesList.filter((x) => x.type === 'NOTES');
      if (notes.length > 0) {
        notes.forEach((object) => {
          HmeOwnrOcpntRltrNotes.push(
            JSON.parse(JSON.parse(JSON.stringify(object.data)))
          );
        });
      }
      if (HmeOwnrOcpntRltrNotes.length > 0) {
        let filterNotes = HmeOwnrOcpntRltrNotes.filter(
          (x) => x.noteVisibleToHomeownerOccupantRealtor === true
        );
        if (filterNotes.length > 0) {
          noteVisibleToHomeownerOccupantRealtor = true;
        }
      }
    }
    let { allowedTabList } = tabSelections;
    const serviceRequestId = this.props.location.state
      ? this.props.location.state.data
        ? this.props.location.state.data.serviceRequestId
        : null
      : null;
    const { orders } = store.getState().onboardingData;
    const showHomeownerDasboardNavigation =
      Object.keys(orders).length > 0 ? true : false;
    const { showOverlay, showOverlayKeyHandoff, suite, feedBackReportPopup } =
      this.state;

    const theme = localStorage.getItem('theme');
    const startDay = serviceRequestTableLocalTime(moment(), 'suitepage');

    const estimatedInOneYeardaysRemaining = moment(
      suite.assetWarrantyOneYear
    ).diff(startDay, 'days');

    const estimatedInTwoYeardaysRemaining = moment(
      suite.assetWarrantyTwoYear
    ).diff(startDay, 'days');
    const inOneYeardaysRemaining = estimatedInOneYeardaysRemaining - 1;
    const inTwoYeardaysRemaining = estimatedInTwoYeardaysRemaining - 1;
    const suiteId = match.params.id.split('&');

    let homeOwnerCheck =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].role.name === 'Home Owner' ||
        user.roles[0].role.name === 'Realtor' ||
        user.roles[0].role.name === 'Occupant' ||
        user.roles[0].role.name === 'Strata Manager')
        ? true
        : false;
    let homeOwnerOccupentCheck =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].role.name === 'Home Owner' ||
        user.roles[0].role.name === 'Realtor' ||
        user.roles[0].role.name === 'Occupant')
        ? true
        : false;
    let activeTab = 0;
    let location = this.props.location;
    if (location && location.state && location.state.activeTab) {
      activeTab =
        this.props.walkThroughs.some((item) => {
          if (item.walkthroughType === 'Home Owner Walk-through') {
            return (
              item.status === 'Guided Walk Through' ||
              item.status === 'Self-Guided Walk Through' ||
              item.status === 'In Progress Home Only' ||
              item.status === 'In Progress Home' ||
              item.status === 'In Progress' ||
              item.status === 'Begin' ||
              item.status === 'Schedule'
            );
          }
        }) && this.props.walkThroughs.length > 0
          ? location.state.activeTab + 1
          : location.state.activeTab;
    } else {
      let string = window.location.href;
      let splitValue = string.split('activeTab=')[1];
      if (splitValue !== undefined) {
        activeTab = Number(splitValue);
      }
    }
    let isFromDashBoard =
      location &&
      location.state &&
      location.state.from &&
      location.state.from === 'Dashboard'
        ? true
        : false;

    let linkView = false;
    if (
      user.roles[0].role.name === 'Admin' ||
      user.roles[0].role.name === 'Super Admin' ||
      user.roles[0].role.name === 'Property Developer' ||
      user.roles[0].role.name === 'Strata Manager'
    ) {
      linkView = true;
    }

    const tabs = [
      {
        localLabel: 'Rooms and Items',
        label: variables.roomsAndItems,
        count: counts.assetsCount ? counts.assetsCount.toString() : '0',
        content: (
          <SuiteAssets
            suite={suite}
            property={property}
            history={this.props.history}
          />
        ),
      },
      {
        localLabel: branding.text.serviceRequest + 's',
        label: branding.text.serviceRequest + 's',
        count: counts.serviceRequestsCount
          ? counts.serviceRequestsCount.toString()
          : '0',
        content: <SuiteServiceRequests suite={suite} />,
      },
      {
        localLabel: 'Messages & Announcements',
        label: 'Messages',
        count: counts.messagesCount ? counts.messagesCount.toString() : '0',
        content: (
          <SuiteMessages
            suite={suite}
            history={this.props.history}
            property={property}
            url={PATHS.SUITES_VIEW.replace(':id', match.params.id)}
          />
        ),
      },
      {
        localLabel: 'Manuals & Documents',
        label: 'Manuals & Documents',
        count: counts.documentsCount ? counts.documentsCount.toString() : '0',
        content: <SuiteDocuments suite={suite} />,
      },
      {
        localLabel: 'Maintenance Reminders',
        label: 'Maintenance Reminders',
        count: counts.maintainanceGuideCount
          ? counts.maintainanceGuideCount.toString()
          : '0',
        content: <SuiteMaintainanceGuide suite={suite} />,
      },
      {
        localLabel: 'FAQs',
        label: 'FAQs',
        count: counts.faqsCount ? counts.faqsCount.toString() : '0',
        content: <SuiteFaqs suite={suite} />,
      },
      {
        localLabel: 'Notes',
        label: 'Notes',
        count: counts.notesCount ? counts.notesCount.toString() : '0',
        content: <SuiteNotes suite={suite} />,
      },
      {
        localLabel: 'WalkThrough',
        label: 'WalkThrough',
        count: counts.walkthroughsCount
          ? counts.walkthroughsCount.toString()
          : '0',
        content: (
          <SuiteWalkThroughs
            suite={suite}
            property={property}
            isEventShow={this.state.isEventShow}
          />
        ),
      },
      {
        localLabel: 'People',
        label: 'People',
        count: counts.peopleCount ? counts.peopleCount.toString() : '0',
        content: (
          <SuiteUsers
            suite={suite}
            property={property}
            onFetchSuiteData={() => this.fetchSuiteById(suite.id)}
          />
        ),
      },
    ];
    let comp = allowedTabList.map((item, index) => {
      let tenantObj = tabs.filter((tn) => tn.localLabel === item.name)[0];
      return tenantObj;
    });
    let filterTilesComp = comp.filter(function (element) {
      return element !== undefined;
    });
    let parkingDetails = allowedTabList.filter(
      (tn) => tn.name === 'Parking Details'
    )[0];
    let forRestUser = [
      <>
        {feedBackReportPopup && <FeedBack />}
        <Metrics title="warranty details" items={[]} />

        {suite.assetWarrantyDefaultStartDate && (
          <div
            className="metrics__key"
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              display: 'grid',
            }}
          >
            <div>
              {`Warranty start date : ${moment(
                suite.assetWarrantyDefaultStartDate
              )
                .utc(false)
                .format('MM/DD/YYYY')}`}
            </div>
          </div>
        )}
        <div
          className="metrics__key"
          style={{
            paddingTop: 5,
            paddingBottom: 5,
            display: 'grid',
          }}
        >
          <div>
            1 Year Warranty :{' '}
            {suite.assetWarrantyOneYear
              ? theme === 'Albaster'
                ? `${
                    inOneYeardaysRemaining < 0 ? 0 : inOneYeardaysRemaining
                  } remaining days`
                : moment
                    .utc(suite.assetWarrantyOneYear)
                    .subtract(1, 'days')
                    .format('MM/DD/YYYY')
              : ''}
          </div>
        </div>
        <div
          className="metrics__key"
          style={{
            paddingTop: 5,
            paddingBottom: 5,
            display: 'grid',
          }}
        >
          <div>
            2 Year Warranty :{' '}
            {suite.assetWarrantyTwoYear
              ? theme === 'Albaster'
                ? `${
                    inTwoYeardaysRemaining < 0 ? 0 : inTwoYeardaysRemaining
                  } remaining days`
                : moment
                    .utc(suite.assetWarrantyTwoYear)
                    .subtract(1, 'days')
                    .format('MM/DD/YYYY')
              : ''}
          </div>
        </div>
        {suite.warrantyAddress !== 'Add' && (
          <div
            className="metrics__key"
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              display: 'grid',
            }}
          >
            <div>Warranty Address</div>
            <div style={{ fontSize: 10 }}>
              {suite.warrantyAddress ? suite.warrantyAddress : ''}
            </div>
          </div>
        )}
        {/* </div> */}
      </>,
      <Metrics
        items={[
          {
            key: 'Active',
            value: counts.serviceActivesCount ? counts.serviceActivesCount : 0,
          },
          {
            key: 'Closed',
            value: counts.serviceArchivedCount
              ? counts.serviceArchivedCount
              : 0,
          },
        ]}
      />,
      suite.parkingStalls?.length || suite.storageLockers?.length ? (
        <Card
          body={
            <div style={{ marginLeft: -10 }}>
              <Tenant
                headline={'PARKING STALLS'}
                strapline={
                  <div style={{ padding: 2 }}>
                    {suite.parkingStalls && suite.parkingStalls.length > 0
                      ? suite.parkingStalls.map((ps, index) => {
                          return (
                            ps.name +
                            (suite.parkingStalls.length - 1 === index
                              ? ''
                              : ', ')
                          );
                        })
                      : 'No parking slots.'}
                  </div>
                }
              />
              <br />
              <Tenant
                headline={'STORAGE LOCKERS'}
                strapline={
                  <div style={{ padding: 2 }}>
                    {suite.storageLockers && suite.storageLockers.length > 0
                      ? suite.storageLockers.map((ps, index) => {
                          return (
                            ps.name +
                            (suite.storageLockers.length - 1 === index
                              ? ''
                              : ', ')
                          );
                        })
                      : 'No storage lockers.'}
                  </div>
                }
              />
            </div>
          }
        />
      ) : null,
      suite.keyFobs?.length || suite.numberOfKeys > 0 ? (
        <Card
          body={
            <div style={{ marginLeft: -10 }}>
              <Tenant
                headline={'KEY FOBS'}
                strapline={
                  <div style={{ padding: 2 }}>
                    {suite.keyFobs && suite.keyFobs.length > 0
                      ? suite.keyFobs.map((ps, index) => {
                          return (
                            ps.name +
                            (suite.keyFobs.length - 1 === index ? '' : ', ')
                          );
                        })
                      : 'No key fobs'}
                  </div>
                }
              />
              <br />
              <Tenant
                headline={'PHYSICAL KEYS'}
                strapline={
                  <div style={{ padding: 2 }}>{suite.numberOfKeys}</div>
                }
              />
            </div>
          }
        />
      ) : null,
      suite && suite.isSpark === true && (
        <Card
          body={
            <div>
              <div
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
                onClick={() => this.onFetchMoreDetails()}
              >
                More Details
              </div>
            </div>
          }
        />
      ),
    ];
    let forHomeownerRealtorUser = [
      <>
        <Metrics title="warranty details" items={[]} />

        {suite.assetWarrantyDefaultStartDate && (
          <div
            className="metrics__key"
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              display: 'grid',
            }}
          >
            <div>
              {`Warranty start date : ${moment(
                suite.assetWarrantyDefaultStartDate
              )
                .utc(false)
                .format('MM/DD/YYYY')}`}
            </div>
          </div>
        )}
        <div
          className="metrics__key"
          style={{
            paddingTop: 5,
            paddingBottom: 5,
            display: 'grid',
          }}
        >
          <div>
            1 Year Warranty :{' '}
            {suite.assetWarrantyOneYear
              ? theme === 'Albaster'
                ? `${
                    inOneYeardaysRemaining < 0 ? 0 : inOneYeardaysRemaining
                  } remaining days`
                : moment
                    .utc(suite.assetWarrantyOneYear)
                    .subtract(1, 'days')
                    .format('MM/DD/YYYY')
              : ''}
          </div>
        </div>
        <div
          className="metrics__key"
          style={{
            paddingTop: 5,
            paddingBottom: 5,
            display: 'grid',
          }}
        >
          <div>
            2 Year Warranty :{' '}
            {suite.assetWarrantyTwoYear
              ? theme === 'Albaster'
                ? `${
                    inTwoYeardaysRemaining < 0 ? 0 : inTwoYeardaysRemaining
                  } remaining days`
                : moment
                    .utc(suite.assetWarrantyTwoYear)
                    .subtract(1, 'days')
                    .format('MM/DD/YYYY')
              : ''}
          </div>
        </div>

        <div
          className="metrics__key"
          style={{
            paddingTop: 5,
            paddingBottom: 5,
            display: 'grid',
          }}
        >
          <div>Warranty Address</div>
          <div style={{ fontSize: 10 }}>
            {suite.warrantyAddress ? suite.warrantyAddress : ''}
          </div>
        </div>
      </>,
      <Metrics
        items={[
          {
            key: 'Active',
            value: counts.serviceActivesCount ? counts.serviceActivesCount : 0,
          },
          {
            key: 'Closed',
            value: counts.serviceArchivedCount
              ? counts.serviceArchivedCount
              : 0,
          },
        ]}
      />,
      <Card
        title={variables.homeOwner}
        body={
          suite.homeOwners && suite.homeOwners.id ? (
            <Tenant
              headline={
                linkView ? (
                  <Link
                    to={{
                      pathname: PATHS.CONTACTS_VIEW.replace(
                        ':id',
                        suite.homeOwners.id
                      ),
                      state: { isFromDashBoard: isFromDashBoard },
                    }}
                  >
                    {suite.homeOwners.firstname} {suite.homeOwners.lastname}
                  </Link>
                ) : (
                  suite.homeOwners.firstname + ' ' + suite.homeOwners.lastname
                )
              }
              strapline={onRequestPhoneCall(suite.homeOwners.phone)}
              avatar={<Avatar url={'/assets/banner-property.png'} />}
            />
          ) : (
            <></>
          )
        }
      />,
      suite && suite.isSpark === true && (
        <Card
          body={
            <div>
              <div
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
                onClick={() => this.onFetchMoreDetails()}
              >
                More Details
              </div>
            </div>
          }
        />
      ),
    ];
    if (suite) {
      return (
        <div>
          {suite.number ? (
            <WithNavigation
              title={suite.number}
              top={
                <HeadingWithDetails
                  style={{
                    backgroundImage: 'url(/assets/banner-property.png)',
                  }}
                  breadcrumb={
                    serviceRequestId != null ? (
                      <Breadcrumb
                        to={PATHS.SERVICE_REQUESTS_VIEW.replace(
                          ':id',
                          serviceRequestId
                        )}
                        label="Service Request"
                      />
                    ) : isFromDashBoard ||
                      user.roles[0].role.name === 'Home Owner' ||
                      user.roles[0].role.name === 'Realtor' ? (
                      location.state && location.state.navigateTo ? (
                        <Breadcrumb
                          to={
                            location.state && location.state.navigateTo
                              ? location.state.navigateTo
                              : PATHS.DASHBOARD
                          }
                          label={
                            location.state && location.state.navigateTo
                              ? 'Inbox'
                              : 'Dashboard'
                          }
                        />
                      ) : (
                        showHomeownerDasboardNavigation && (
                          <Breadcrumb
                            to={
                              location.state && location.state.navigateTo
                                ? location.state.navigateTo
                                : PATHS.DASHBOARD
                            }
                            label={
                              location.state && location.state.navigateTo
                                ? 'Inbox'
                                : 'Dashboard'
                            }
                          />
                        )
                      )
                    ) : (
                      <Breadcrumb
                        to={
                          location.state && location.state.navigateTo
                            ? location.state.navigateTo
                            : {
                                pathname: PATHS.PROPERTIES_VIEW.replace(
                                  ':id',
                                  suiteId[0]
                                ),
                              }
                        }
                        label={property.name}
                      />
                    )
                  }
                  headline={
                    <Headline
                      suiteName={suite?.number || ''}
                      showProfile={suite?.primaryContact}
                      name={
                        suite?.primaryContact?.firstname +
                        ' ' +
                        suite?.primaryContact?.lastname
                      }
                      disableLink={!suite?.primaryContact?.id}
                      profileLinkTo={{
                        pathname: PATHS.CONTACTS_VIEW.replace(
                          ':id',
                          suite?.primaryContact?.id
                        ),
                        state: { isFromDashBoard: isFromDashBoard },
                      }}
                      phone={suite?.primaryContact?.phone}
                    />
                  }
                  items={
                    parkingDetails === undefined &&
                    (user.roles[0].role.name === 'Home Owner' ||
                      user.roles[0].role.name === 'Realtor')
                      ? forHomeownerRealtorUser
                      : forRestUser
                  }
                  actions={
                    homeOwnerCheck ? null : (
                      <>
                        {suite.mobileSyncAllowed !== undefined ? (
                          <MobileDownloadIcon
                            property={suite}
                            onClick={() => this.toggleMobileSync()}
                          />
                        ) : null}
                        {suite.isKeyHandOff === true ||
                        (suiteFormData &&
                          suiteFormData.isKeyHandOff === true) ? (
                          <Button
                            color="semantic"
                            onClick={() => this.reRenderKeyPickupPdf()}
                            label={<Icon glyph="redo-alt" weight="solid" />}
                          />
                        ) : (!suite.isKeyHandOff &&
                            user.roles[0].role.name === 'Property Developer') ||
                          user.roles[0].role.name === 'Admin' ||
                          user.roles[0].role.name === 'Super Admin' ? (
                          <Button
                            color="semantic"
                            onClick={() => {
                              this.fetchDetails();
                            }}
                            label={<Icon glyph="key" weight="solid" />}
                          />
                        ) : (
                          ''
                        )}
                        <Button
                          color="semantic"
                          onClick={() => {
                            this.setState({ showOverlay: true });
                            onSetSuiteFormData(suite);
                          }}
                          label={<Icon glyph="pencil" weight="solid" />}
                        />
                        <Button
                          color="semantic"
                          onClick={() =>
                            window.confirm(
                              `Are you sure you want to delete ${suite.number}?`
                            ) && this.onDeleteUnit(suite.id)
                          }
                          label={
                            <Icon
                              glyph="trash"
                              weight="solid"
                              style={{ color: '#C00' }}
                            />
                          }
                        />
                        <Overlay
                          showOverlay={showOverlay}
                          content={
                            <SuiteForm
                              onClose={() =>
                                this.setState({ showOverlay: false }, () =>
                                  onClearSuiteFormData()
                                )
                              }
                              onSaveSuite={(data, areas, floorImage) =>
                                this.onSaveSuite(data, areas, floorImage)
                              }
                            />
                          }
                        />
                      </>
                    )
                  }
                />
              }
              bottom={
                <>
                  {this.props.walkThroughs && (
                    <Tabs
                      from={'suite'}
                      activeTab={activeTab}
                      hideEmptyTabs={homeOwnerOccupentCheck}
                      items={
                        user.roles[0].role.name === 'Home Owner' ||
                        user.roles[0].role.name === 'Realtor'
                          ? filterTilesComp
                          : user.roles[0].role.name === 'Property Developer' ||
                              user.roles[0].role.name === 'Admin' ||
                              user.roles[0].role.name === 'Super Admin' ||
                              user.roles[0].role.name === 'Occupant'
                            ? this.props.walkThroughs.some((item) => {
                                if (
                                  item.walkthroughType ===
                                  'Home Owner Walk-through'
                                ) {
                                  return (
                                    item.status === 'Guided Walk Through' ||
                                    item.status ===
                                      'Self-Guided Walk Through' ||
                                    item.status === 'In Progress Home Only' ||
                                    item.status === 'In Progress Home' ||
                                    item.status === 'In Progress' ||
                                    item.status === 'Begin' ||
                                    item.status === 'Schedule'
                                  );
                                }
                              }) && this.props.walkThroughs.length > 0
                              ? [
                                  {
                                    label: 'WalkThrough',
                                    count: counts.walkthroughsCount
                                      ? counts.walkthroughsCount.toString()
                                      : '0',
                                    content: (
                                      // <SuiteAssets suite={suite} property={property} />
                                      <SuiteWalkThroughs
                                        suite={suite}
                                        property={property}
                                        isEventShow={this.state.isEventShow}
                                      />
                                    ),
                                  },
                                  {
                                    label: variables.roomsAndItems,
                                    count: counts.assetsCount
                                      ? counts.assetsCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteAssets
                                        suite={suite}
                                        property={property}
                                        history={this.props.history}
                                      />
                                    ),
                                  },
                                  {
                                    label: branding.text.serviceRequest + 's',
                                    count: counts.serviceRequestsCount
                                      ? counts.serviceRequestsCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteServiceRequests suite={suite} />
                                    ),
                                  },
                                  {
                                    label: 'Manuals & Documents',
                                    count: counts.documentsCount
                                      ? counts.documentsCount.toString()
                                      : '0',
                                    content: <SuiteDocuments suite={suite} />,
                                  },
                                  {
                                    label: 'Messages',
                                    count: counts.messagesCount
                                      ? counts.messagesCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteMessages
                                        suite={suite}
                                        history={this.props.history}
                                        property={property}
                                        url={PATHS.SUITES_VIEW.replace(
                                          ':id',
                                          match.params.id
                                        )}
                                      />
                                    ),
                                  },
                                  {
                                    label: 'Maintenance Reminders',
                                    count: counts.maintainanceGuideCount
                                      ? counts.maintainanceGuideCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteMaintainanceGuide suite={suite} />
                                    ),
                                  },
                                  {
                                    label: 'People',
                                    count: counts.peopleCount
                                      ? counts.peopleCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteUsers
                                        suite={suite}
                                        property={property}
                                        onFetchSuiteData={() =>
                                          this.fetchSuiteById(suite.id)
                                        }
                                      />
                                    ),
                                  },
                                  /*
                                      Modified By: Sai Prasad
                                      Modified Date: 09/09/2022
                                      Jira Ticket: JUN-3175
                                      Description: added faqs tab under suite
                                  */
                                  {
                                    label: 'FAQs',
                                    count: counts.faqsCount
                                      ? counts.faqsCount.toString()
                                      : '0',
                                    content: <SuiteFaqs suite={suite} />,
                                  },
                                  homeOwnerOccupentCheck &&
                                  noteVisibleToHomeownerOccupantRealtor == false
                                    ? {}
                                    : {
                                        label: 'Notes',
                                        count: counts.notesCount
                                          ? counts.notesCount.toString()
                                          : '0',
                                        content: <SuiteNotes suite={suite} />,
                                      },
                                ]
                              : [
                                  {
                                    label: variables.roomsAndItems,
                                    count: counts.assetsCount
                                      ? counts.assetsCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteAssets
                                        suite={suite}
                                        property={property}
                                        history={this.props.history}
                                      />
                                    ),
                                  },
                                  {
                                    label: branding.text.serviceRequest + 's',
                                    count: counts.serviceRequestsCount
                                      ? counts.serviceRequestsCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteServiceRequests suite={suite} />
                                    ),
                                  },
                                  {
                                    label: 'Manuals & Documents',
                                    count: counts.documentsCount
                                      ? counts.documentsCount.toString()
                                      : '0',
                                    content: <SuiteDocuments suite={suite} />,
                                  },
                                  {
                                    label: 'Messages',
                                    count: counts.messagesCount
                                      ? counts.messagesCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteMessages
                                        suite={suite}
                                        history={this.props.history}
                                        property={property}
                                        url={PATHS.SUITES_VIEW.replace(
                                          ':id',
                                          match.params.id
                                        )}
                                      />
                                    ),
                                  },
                                  {
                                    label: 'Maintenance Reminders',
                                    count: counts.maintainanceGuideCount
                                      ? counts.maintainanceGuideCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteMaintainanceGuide suite={suite} />
                                    ),
                                  },
                                  {
                                    label: 'People',
                                    count: counts.peopleCount
                                      ? counts.peopleCount.toString()
                                      : '0',
                                    content: (
                                      <SuiteUsers
                                        suite={suite}
                                        property={property}
                                        onFetchSuiteData={() =>
                                          this.fetchSuiteById(suite.id)
                                        }
                                      />
                                    ),
                                  },
                                  /*
                                      Modified By: Sai Prasad
                                      Modified Date: 09/09/2022
                                      Jira Ticket: JUN-3175
                                      Description: added faqs tab under suite
                                  */
                                  {
                                    label: 'FAQs',
                                    count: counts.faqsCount
                                      ? counts.faqsCount.toString()
                                      : '0',
                                    content: <SuiteFaqs suite={suite} />,
                                  },

                                  homeOwnerOccupentCheck &&
                                  noteVisibleToHomeownerOccupantRealtor ===
                                    false
                                    ? {}
                                    : {
                                        label: 'Notes',
                                        count: counts.notesCount
                                          ? counts.notesCount.toString()
                                          : '0',
                                        content: <SuiteNotes suite={suite} />,
                                      },
                                  {
                                    label: 'WalkThrough',
                                    count: counts.walkthroughsCount
                                      ? counts.walkthroughsCount.toString()
                                      : '0',
                                    content: (
                                      // <SuiteAssets suite={suite} property={property} />
                                      <SuiteWalkThroughs
                                        suite={suite}
                                        property={property}
                                        isEventShow={this.state.isEventShow}
                                      />
                                    ),
                                  },
                                ]
                            : [
                                {
                                  label: variables.roomsAndItems,
                                  count: counts.assetsCount
                                    ? counts.assetsCount.toString()
                                    : '0',
                                  content: (
                                    <SuiteAssets
                                      suite={suite}
                                      property={property}
                                      history={this.props.history}
                                    />
                                  ),
                                },
                                {
                                  label: branding.text.serviceRequest + 's',
                                  count: counts.serviceRequestsCount
                                    ? counts.serviceRequestsCount.toString()
                                    : '0',
                                  content: (
                                    <SuiteServiceRequests suite={suite} />
                                  ),
                                },
                                {
                                  label: 'Messages',
                                  count: counts.messagesCount
                                    ? counts.messagesCount.toString()
                                    : '0',
                                  content: (
                                    <SuiteMessages
                                      suite={suite}
                                      history={this.props.history}
                                      property={property}
                                      url={PATHS.SUITES_VIEW.replace(
                                        ':id',
                                        match.params.id
                                      )}
                                    />
                                  ),
                                },
                                {
                                  label: 'Manuals & Documents',
                                  count: counts.documentsCount
                                    ? counts.documentsCount.toString()
                                    : '0',
                                  content: <SuiteDocuments suite={suite} />,
                                },
                                {
                                  label: 'Maintenance Reminders',
                                  count: counts.maintainanceGuideCount
                                    ? counts.maintainanceGuideCount.toString()
                                    : '0',
                                  content: (
                                    <SuiteMaintainanceGuide suite={suite} />
                                  ),
                                },
                                {
                                  label: 'FAQs',
                                  count: counts.faqsCount
                                    ? counts.faqsCount.toString()
                                    : '0',
                                  content: <SuiteFaqs suite={suite} />,
                                },
                                homeOwnerOccupentCheck &&
                                noteVisibleToHomeownerOccupantRealtor === false
                                  ? {}
                                  : {
                                      label: 'Notes',
                                      count: counts.notesCount
                                        ? counts.notesCount.toString()
                                        : '0',
                                      content: <SuiteNotes suite={suite} />,
                                    },
                              ]
                      }
                    />
                  )}
                  <Overlay
                    showOverlay={propertyWalkThroughFormIsVisible}
                    content={
                      <PropertyWalkThroughForm
                        onClose={() => console.log('')}
                      />
                    }
                  />
                  <Overlay
                    showOverlay={showOverlayKeyHandoff}
                    content={
                      <Keyhandoff
                        onSubmitKeyhandOffProcess={
                          this.props.onSubmitKeyhandOffProcess
                        }
                        onClose={() => {
                          this.setState({ showOverlayKeyHandoff: false }, () =>
                            onClearSuiteFormData()
                          );
                        }}
                        // onSaveSuite={onSaveSuite}
                      />
                    }
                  />
                  {moreDetails && moreDetails.isEnableLoader ? (
                    <Loader center={true} />
                  ) : null}
                  {moreDetails && moreDetails.isMoreDetails ? (
                    <MoreDetails
                      closePopup={() => this.props.onClearMoreDetails()}
                      details={moreDetails.moreData}
                    />
                  ) : null}
                </>
              }
            />
          ) : (
            <Loader center={true} />
          )}
        </div>
      );
    }

    return <Loader center={true} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  let suiteId = ownProps.match.params.id.split('&');

  let user = selectAuthenticatedUser(state);
  let role = user.roles[0] && user.roles[0].role.name;
  return {
    counts: selectCounts(state),
    suites: selectSuites(state),
    suite: selectSuiteById(state, suiteId[1]),
    serviceRequests: selectServiceRequests(state),
    property: selectPropertyById(
      state,
      suiteId.length === 3 ? suiteId[2] : suiteId[0]
    ),
    notes: selectNotes(state),
    documents: selectDocuments(state),
    user,
    messages: selectMessages(state),
    assets: selectAssets(state),
    walkThroughs: selectWalkThroughByRole(state, role),
    suiteUsers: selectSuiteUsers(state),
    properties: selectProperties(state),
    propertyManagerDetails: selectpropertyManagerDetails(state),
    propertyWalkThroughFormIsVisible:
      selectPropertyWalkThroughFormIsVisible(state),
    formOptions: selectFormOptions(state),
    suiteFormData: selectSuiteFormData(state),
    moreDetails: state.moreDetails,
    loader: selectLoader(state),
    tabSelections: state.tabSelections,
    notesList: state.notes,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClearSuiteUsers: clearSuiteUsers,
      clearCountsDone: clearCountsDone,
      onFetchSuiteCounts: fetchSuiteCounts,
      onFetchProperties: fetchProperties,
      onFetchPropertySuites: fetchPropertySuites,
      onFetchCalendlyLink: fetchCalendlyLink,
      onFetchPropertyManagerDetails: fetchPropertyManagerDetails,
      onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
      onfetchAssetsBySuiteId: fetchAssetsBySuiteId,
      onUpdateSuite: updateSuite,
      onDeleteUnit: deleteUnit,
      onSetSuiteFormData: setSuiteFormData,
      onClearSuiteFormData: clearSuiteFormData,
      clearServiceRequests,
      clearAssets,
      clearMessages,
      clearFaqsNotesDocuments,
      fetchSuiteWalkThroughs,
      getAllUserTypeRoles,
      startFormLoading,
      stopFormLoading,
      onSubmitKeyhandOffProcess: onSubmitKeyhandOffProcess,
      onFetchSuiteDetails: onFetchSuiteDetails,
      onFetchMoreDetails: onFetchMoreDetails,
      onClearMoreDetails: onClearMoreDetails,
      fetchtAllowedTabList: fetchtAllowedTabList,
      clearNotes,
      onReRenderKeyPickupPdf: reRenderKeyPickupPdf,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Suite);
